import { MyleHelper } from "@/Common/Helpers/MyleHelper";
import { TaskSettingsContainer_OptimizedV2State } from "@/Communications/Components/Search/TaskSettingsContainer_OptimizedV2";

class TaskSearchSettings {
    public IsAllSitesChecked: boolean;
    public IsAllCliniciansChecked: boolean;
    public IsAllSharedWithChecked: boolean;
    public IsAllStatusChecked: boolean;
    public IsAllPriorityChecked: boolean;
    public SiteIds: string[];
    public ClinicianIds: string[];
    public SharedWithIds: string[];
    public Status: string[];
    public Priorities: string[];
    public PageSize: number;
    public OrderByPriorityFirst: boolean;

    public static FromModel(model: TaskSettingsContainer_OptimizedV2State): TaskSearchSettings {
        let helper = new MyleHelper();

        let display: TaskSearchSettings = new TaskSearchSettings();
        display.IsAllSitesChecked = model.isAllSitesChecked;
        display.IsAllCliniciansChecked = model.isAllCliniciansChecked;
        display.IsAllSharedWithChecked = model.isAllSharedWithChecked;
        display.IsAllStatusChecked = model.isAllStatusesChecked;
        display.IsAllPriorityChecked = model.isAllPrioritiesChecked;
        display.SiteIds = helper.GetCheckedItemsFromICheckableList(Immutable.List(model.sites)).map(x => x.Id).toArray();
        display.ClinicianIds = helper.GetCheckedItemsFromICheckableList(Immutable.List(model.clinicians)).map(x => x.Id).toArray();
        display.SharedWithIds = helper.GetCheckedItemsFromICheckableList(Immutable.List(model.sharedWith)).map(x => x.Id).toArray();
        display.Status = helper.GetCheckedItemsFromICheckableList(Immutable.List(model.statuses)).map(x => x.Id).toArray();
        display.Priorities = helper.GetCheckedItemsFromICheckableList(Immutable.List(model.priorities)).map(x => x.Id).toArray();
        display.PageSize = model.selectedPageSizeOption;
        display.OrderByPriorityFirst = model.orderByPriorityFirst;
        return display;
    }
}

export { TaskSearchSettings };
